import { Eyebrow } from './icons'

// Figma 29.09 "The Arvance Way", spec §2.5; replaces the old Workflow/Tools section.
// Where the 360 frame words a chip differently (§6 D4), `mobile` holds its copy.
const STEPS = [
  {
    title: 'Establish the Value',
    text: 'Enter an address and estimate ARV with scored comps.',
    chips: [
      { label: 'ARV Estimate', mobile: 'Estimated ARV', value: '$408K' },
      { label: 'Comp Quality', value: 'Excellent' },
    ],
  },
  {
    title: 'Test the Numbers',
    text: 'Adjust financing, rehab, and exit assumptions.',
    chips: [
      { label: 'Projected Profit', value: '$47K' },
      { label: 'Flip ROI', value: '31%' },
    ],
  },
  {
    title: 'Make the Decision',
    text: 'Score the deal and track your next steps.',
    chips: [
      { label: 'Deal Score', mobile: 'Deal score', value: '84' },
      { label: 'Decision', value: 'Pursue' },
    ],
  },
]

const Chip = ({ label, mobile, value }) => (
  <p className="self-start inline-flex items-center h-7 canvas:h-8 px-2 rounded-[3.78px] canvas:rounded-[4px] bg-[#E9F0E5] border-[0.5px] border-brand-fieldBdr text-[16px] canvas:text-[18px] leading-6 text-brand-secondary whitespace-nowrap">
    <span className="font-bold">
      {mobile ? (
        <>
          <span className="canvas:hidden">{mobile}</span>
          <span className="hidden canvas:inline">{label}</span>
        </>
      ) : (
        label
      )}
    </span>
    <span className="whitespace-pre">: {value}</span>
  </p>
)

const StepCard = ({ n, title, text, chips }) => (
  <li className="relative flex flex-col bg-white border border-brand-fieldBdr rounded-[6.67px] canvas:rounded-lg px-[23px] pt-[23px] pb-[23px] canvas:w-[360px] canvas:h-[280px] canvas:px-[31px] canvas:pt-[33px] canvas:pb-[39px]">
    <div className="flex items-center gap-2">
      {/* Mobile: 28 circle inside the card. Desktop: 40 circle centred on the card's top edge. */}
      <span className="w-7 h-7 canvas:w-10 canvas:h-10 canvas:absolute canvas:top-[-21px] canvas:left-[31px] rounded-full bg-brand-accent text-white text-[16px] canvas:text-[20px] font-semibold flex items-center justify-center shrink-0">
        {n}
      </span>
      <h3 className="text-[18px] leading-6 canvas:text-[20px] canvas:leading-7 font-bold text-brand-dark">{title}</h3>
    </div>
    <p className="mt-3 canvas:mt-[26px] text-[16px] leading-6 canvas:text-[18px] canvas:leading-7 text-brand-dark">{text}</p>
    <div className="mt-3 canvas:mt-6 flex flex-col gap-3 canvas:gap-2">
      {chips.map((c) => (
        <Chip key={c.label} {...c} />
      ))}
    </div>
  </li>
)

const ArvanceWay = () => (
  <section className="relative z-10 bg-transparent">
    <div className="max-w-[640px] canvas:max-w-canvas mx-auto px-5 canvas:px-0 pt-2 canvas:pt-[114px] flex flex-col items-center text-center">
      <Eyebrow>From Address to Decision</Eyebrow>
      <h2 className="mt-4 text-[28px] leading-9 canvas:text-[40px] canvas:leading-10 font-extrabold text-brand-dark">
        The <span className="text-brand-accent">Arvance</span> Way
      </h2>
      {/* D4: the frames carry different subheadings; each width keeps its own. */}
      <p className="canvas:mt-[9px] text-[16px] leading-6 canvas:text-[20px] canvas:leading-7 font-medium text-brand-dark">
        <span className="canvas:hidden">See how one property becomes a confident investment decision.</span>
        <span className="hidden canvas:inline">Estimate the value, model the returns, and choose your next move.</span>
      </p>

      <ol className="mt-[31px] canvas:mt-[52px] w-full canvas:w-auto flex flex-col canvas:flex-row gap-3 canvas:gap-[19px] text-left">
        {STEPS.map((step, i) => (
          <StepCard key={step.title} n={i + 1} {...step} />
        ))}
      </ol>
    </div>
  </section>
)

export default ArvanceWay
